































import { Component, Prop, Vue } from "vue-property-decorator";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ITemplateCategory } from "@/models/templates";
import { UpmindObjectTypes } from "@/data/enums/objects";

@Component({
  components: {
    Treeselect,
    "template-content": () =>
      import("@/components/app/global/templates/contentForm.vue")
  }
})
export default class CategorySelectField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: UpmindObjectTypes;

  @Prop({ required: true })
  public categories!: ITemplateCategory[];

  @Prop({ default: false })
  public isDisabled!: string;

  @Prop({ default: false })
  public isLoading!: string;

  // Methods

  public onInput(value: UpmindObjectTypes) {
    this.$emit("input", value);
  }
}
